import React from 'react'

const ProfileImage = ({decodeToken, nav, signOut, auth}) => {
  return (
    <>
    {auth.username ? (
            <div className="flex items-center md:order-2">
            <button type="button" style={{width: '100%'}} className="hidden lg:flex flex mr-3 text-sm bg-gray-800 rounded-full md:mr-0 focus:ring-4 focus:ring-gray-300" id="user-menu-button" aria-expanded="false" data-dropdown-toggle="user-dropdown" data-dropdown-placement="bottom">
                <img className="w-12 h-12 rounded-full" src={decodeToken.picture || 'https://img.icons8.com/office/344/gender-neutral-user.png'} alt="Logo" />
            </button>
            {nav && (
                <div className={!nav ? 'hidden' : 'absolute lg:hidden'}>
                    <button onClick={signOut}>Sign Out</button>
                </div>
                )}
                
                <div className="z-50 my-4 py-30 divide-y divide-gray-100 hidden lg:flex" style={{width: '100%'}} id="user-dropdown">
                    <div className="py-3 px-4">
                    <span className="block text-sm text-gray-900 hidden lg:flex">{auth.username}</span>
                    <span className="block text-sm font-medium text-gray-700 truncate">{auth.email}</span>
                    </div>
                </div>

                <div className='hidden md:flex pr-4'>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 cursor-pointer" onClick={signOut}>
                        <path d="M18 1.5c2.9 0 5.25 2.35 5.25 5.25v3.75a.75.75 0 01-1.5 0V6.75a3.75 3.75 0 10-7.5 0v3a3 3 0 013 3v6.75a3 3 0 01-3 3H3.75a3 3 0 01-3-3v-6.75a3 3 0 013-3h9v-3c0-2.9 2.35-5.25 5.25-5.25z" />
                    </svg>
                </div> 
            </div>
    ):(
        <div className="flex items-center md:order-2">
            <div className='hidden md:flex pr-4'>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 cursor-pointer">
                <path fillRule="evenodd" d="M12 1.5a5.25 5.25 0 00-5.25 5.25v3a3 3 0 00-3 3v6.75a3 3 0 003 3h10.5a3 3 0 003-3v-6.75a3 3 0 00-3-3v-3c0-2.9-2.35-5.25-5.25-5.25zm3.75 8.25v-3a3.75 3.75 0 10-7.5 0v3h7.5z" clipRule="evenodd" />
            </svg>
            </div> 
        </div>
        )}
        </>
  )
}

export default ProfileImage
